import { render, staticRenderFns } from "./FeuchterTVView.vue?vue&type=template&id=596ccafa&"
import script from "./FeuchterTVView.vue?vue&type=script&lang=js&"
export * from "./FeuchterTVView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports